/* eslint-disable no-undef */
// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileContracts', cobCarrierProfileContracts);

	cobCarrierProfileContracts.$inject = [
		'$location', '$timeout', '$window', '$state', '$stateParams', 'sessionService',
		'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService',
		'authenticationService'
	];

	var $location,
		$timeout,
		$window,
		$state,
		$stateParams,
		sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		authenticationService;
	var subjectMessages, observerMessages;

	function cobCarrierProfileContracts(_$location_,
		_$timeout_, 
		_$window_,
		_$state_,
		_$stateParams_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_authenticationService_) {
		$location = _$location_;
		$timeout = _$timeout_;
		$window = _$window_;
		$state = _$state_;
		$stateParams = _$stateParams_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		authenticationService = _authenticationService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileContracts.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.carrierId = $stateParams.carrierId;
			scope.brokerId = $stateParams.brokerId;
			scope.ajaxIsRunning = false;
			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				readyToSign: sessionService.getCarrierReadyToSign(),
				carrierIsAuthorized: sessionService.isCarrier(),
				signedNewContract: false,
				showConfirmationModal: false,
				searchType: 'brokerName',
				otherTitleOption: 'Other',
				isSubmited: false
			};

			scope.titles = [
				'Chairman',
				'Chief Executive Officer (CEO)',
				'Chief Financial Officer (CFO)',
				'Chief Operations Officer (COO)',
				'Controller',
				'Director of Operations',
				'Executive Vice President',
				'General Manager',
				'Owner',
				'President',
				'Senior Vice President',
				'Vice President',
				scope.m.otherTitleOption
			];

			scope.setIsDirty = setIsDirty;
			scope.onForceGo = onForceGo;
			scope.goToProfile = goToProfile;
			scope.startSigning = startSigning;
			scope.cancelSigning = cancelSigning;
			scope.sign = sign;
			scope.sort = sort;
			scope.brokerClick = brokerClick;
			scope.signatureClick = signatureClick;
			scope.goToBranded = goToBranded;
			scope.validateSigneeFirstField = validateSigneeFirstField;
			scope.validateSigneeLastField = validateSigneeLastField;
			scope.validateSigneeTitleField = validateSigneeTitleField;
			scope.valdiateSigneeTitleOptions = valdiateSigneeTitleOptions;
			scope.getSigneeTitle = getSigneeTitle;
			scope.searchClick = searchClick;
			scope.openModalWindow = openModalWindow,
			scope.closeModalWindow = closeModalWindow,
			scope.logout = logout;

			scope.contractStatus = {
				signed: 'Signed',
				rejected: 'Rejected',
				notSigned: 'NotSigned',
				signing: 'Signing'
			};

			loadData();

			registerObserverHandlers();
			document.title = 'Profile-Contracts';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function loadData() {
			if (scope.m.isBroker && !scope.m.isAdmin) {
				loadBrandedData();
			} else {
				loadBranding();
				if (scope.m.brokerName) {
					loadBrandedData();
				} else {
					loadBrokers();
				}
				if (scope.m.isAdmin) {
					var carrier = sessionService.getCarrierImpersonated();
					if (carrier.dotNumber) {
						carrierRegistrationService.validateDotNumber(carrier.dotNumber).then(function (response) {
							scope.m.carrierIsAuthorized = response.data.validationInfo === 'Authorized';

						});
					}
					else if (carrier.intrastateCode) {
						carrierRegistrationService.validateIntrastateCode(carrier.intrastateState, carrier.intrastateCode).then(function (response) {
							scope.m.carrierIsAuthorized = response.data.validationInfo === 'Authorized';

						});
					}
				}
			}
		}

		function loadBranding() {
			var broker = sessionService.getBrokerBranding();
			if (broker && !scope.m.isBroker) {
				scope.brokerId = broker.brokerId;
				scope.m.brokerName = broker.brokerName;
				scope.m.contractMessage = broker.contractMessage;
				scope.m.contractMessageDisabled = broker.contractMessageDisabled;
				scope.m.logoUrl = sessionService.getBrokerLogoURL();
				loadBrandedData();
			}
		}

		function loadBrandedData() {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_WAITING);

			var documentId = $location.search()['i'];
			var documentStatus = $location.search()['status'];
			if (documentId && documentStatus !== 'DocumentDeclined') {
				$location.url($location.path());
				carrierRegistrationService.facsimileSignatures(documentId)
					.then(loadContractsHelper)
					.finally(function () {
						// User has been redirected back to our app from signing an AssureSign document if they're in this block
						scope.m.signedNewContract = true;
						observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
					});
			} else {
				if (documentStatus) {                 
					$location.url($location.path());
				}
				carrierRegistrationService.lookupContractsAndSignatures(scope.carrierId, scope.brokerId)
					.then(loadContractsHelper)
					.finally(function() {
						observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
					});
				
			}

		}

		function loadContractsHelper(response) {
			scope.m.contracts = response.data.contractSignatures;

			var hasSigned = false;

			for (var i = 0; i < scope.m.contracts.length; i++) {
				setContractStatus(scope.m.contracts[i]);
				scope.m.contracts[i].dateSignedClean = new Date(scope.m.contracts[i].dateSigned);
				if (new Date(scope.m.contracts[i].dateSigned) < new Date(1900, 1, 1)) {
					scope.m.contracts[i].dateSigned = '----';
				}
				if (scope.m.contracts[i].rejected) {
					scope.m.contracts[i].dateSigned = 'Rejected';
				}
				if (!scope.m.contracts[i].signee) {
					scope.m.contracts[i].dateSignedSort = new Date(2101, 12, 12);
				} else if (scope.m.contracts[i].rejected) {
					scope.m.contracts[i].dateSignedSort = new Date(2100, 12, 12);
				} else {
					scope.m.contracts[i].dateSignedSort = scope.m.contracts[i].dateSignedClean;
					hasSigned = true;
				}

				scope.m.contracts[i].signeeClean = scope.m.contracts[i].signee;
				scope.m.contracts[i].signeeTitleClean = scope.m.contracts[i].signeeTitle;
			}
			if (hasSigned) {
				observerService.sendMessageToSubject(scope,
					subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
					'contracts');
			}
			sort('contractName');
		}

		function setContractStatus(contract) {
			if (contract.signee) {
				if (contract.rejected) {
					contract.status = scope.contractStatus.rejected;

					return;
				}
				
				contract.status = scope.contractStatus.signed;

				return;                    
			}

			contract.status = scope.contractStatus.notSigned;
		}

		function loadBrokers() {
			scope.ajaxIsRunning = true;

			setTimeout(function () {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			carrierRegistrationService.lookupBrokers(scope.carrierId)
				.then(function(response) {
					scope.m.allBrokers = response.data.brokers;

					for (var i = 0; i < scope.m.allBrokers.length; i++) {

						if (scope.m.allBrokers[i].lastVisited === '0001-01-01T00:00:00') {
							scope.m.allBrokers[i].lastVisited = '----';
						}
						scope.m.allBrokers[i].href = scope.m.allBrokers[i].domain +
							$state.href('carrierProfile.contracts',
								{ carrierId: $stateParams.carrierId, brokerId: $stateParams.brokerId });
					}
					sort('signedContracts');

				})
				.finally(function () {
					scope.ajaxIsRunning = false;
					observerService
						.sendMessageToSubject(scope,
							subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					if (reloadAjax) {
						reloadAjax = false;
						scope.currentRow = 0;
						scope.totalRows = 0;
						scope.carriers = [];
						setTimeout(function () { getCarriers(); }, 1);
					}
				});
		}

		function loadSignatures(broker) {
			// has signed contracts but no loaded signatures
			if (broker.signedContracts && !broker.signatures) {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_WAITING);
				carrierRegistrationService.lookupSignatures(scope.carrierId, broker.brokerId)
					.then(function(response) {
						broker.signatures = response.data.contractSignatures;

						for (var i = 0; i < broker.signatures.length; i++) {

							broker.signatures[i].dateSignedClean = broker.signatures[i].dateSigned;
							if (broker.signatures[i].rejected) {
								broker.signatures[i].dateSigned = 'Rejected';
							}
						}

						$timeout(function () {
							broker.open = true;
						}, 20);
					})
					.finally(function() {
						observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
					});
			} else {
				broker.open = true;
			}
		}

		function registerObserverHandlers() {

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty) {
						if (!
						confirm('You have not completed the signing process. Contracts are signed using the Sign button at the bottom of the page. Are you sure you want to leave the page?')) {
							event.preventDefault();
						}
					}
				});
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_DOMAIN_DATA_LOADED);
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: navStart },
					{ message: observerMessages.COB_OBSERVER_DOMAIN_DATA_LOADED, handler: loadData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_STATUS_FINISH, handler: setReadyToSign },
				]);
		}

		function navStart(callback) {
			if (scope.m.isDirty) {
				scope.m.showSectionMessage = true;
				scope.pendingCallback = callback;
			} else if (typeof (callback) === 'function') {
				callback();
			}
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have not completed the signing process. Contracts are signed using the Sign button at the bottom of the page. Are you sure you want to leave the page?';
			};
		}

		function clearDirty() {
			scope.m.isDirty = false;
			window.onbeforeunload = undefined;
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function goToProfile() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				'profile');
		}

		function startSigning(contract) {
			hideSigningContractForm(scope.signingContract, scope.contractStatus.notSigned);
			contract.signing = true;
			scope.m.signing = true;
			contract.status = scope.contractStatus.signing;
			scope.signingContract = contract;
		}

		function cancelSigning(contract) {
			hideSigningContractForm(scope.signingContract, scope.contractStatus.notSigned);
			clearDirty();

			contract.signee = '';
			contract.signeeFirst = '';
			contract.signeeLast = '';
			contract.signeeTitle = '';
			contract.signeeOtherTitle = '';
			contract.signeeError = undefined;
			contract.signeeFirstError = undefined;
			contract.signeeLastError = undefined;
			contract.signeeTitleError = undefined;
		}

		function hideSigningContractForm(contract, contractStatus) {
			if(contract) {
				contract.signing = false;
				scope.m.signing = false;
				contract.status = contractStatus;
				scope.signingContract = undefined;
			}
		}

		function sign(contract) {
			validateSigneeFirstField(contract);
			validateSigneeLastField(contract);
			validateSigneeTitleField(contract);

			if (!contract.signeeFirstError && !contract.signeeLastError && !contract.signeeTitleError) {
				contract.signee = contract.signeeFirst + ' ' + contract.signeeLast;
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_WAITING);

				if (contract.isAssureSign) {
					clearDirty();
					carrierRegistrationService
						.signAssuresignContract(
							contract.signee,
							getSigneeTitle(contract),
							scope.brokerId,
							$window.location.href.split('?')[0])
						.then(function(response) {
							$window.location.href = response.data.signatureURL;
						})
						.finally(function() {
							observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
						});
				} else {
					carrierRegistrationService
						.signStandardContract(
							contract.signee,
							getSigneeTitle(contract),
							contract.contractId)
						.then(function(response) {
							contract.dateSigned = response.data.signed;
							hideSigningContractForm(contract, scope.contractStatus.signed);
							scope.m.isSubmited = false;
							clearDirty();
							observerService.sendMessageToSubject(scope,
								subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
								'contracts');
						})
						.finally(function() {
							observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_AJAX_DONE);
						});
				}
				scope.m.signedNewContract = true;
			}   
		}

		function getSigneeTitle(contract) {
			return contract.signeeTitle === scope.m.otherTitleOption ? contract.signeeOtherTitle : contract.signeeTitle;
		}

		function validateSigneeFirstField(contract) {
			if (!contract.signeeFirst) {
				contract.signeeFirstError = 'Valid input is required';
			} else {
				contract.signeeFirstError = '';
			}
		}

		function validateSigneeLastField(contract) {
			if (!contract.signeeLast) {
				contract.signeeLastError = 'Valid input is required';
			} else {
				contract.signeeLastError = '';
			}
		}

		function validateSigneeTitleField(contract) {
			if (!getSigneeTitle(contract)) {
				contract.signeeTitleError = 'Valid input is required';
			} else {
				contract.signeeTitleError = '';
			}
		}

		function valdiateSigneeTitleOptions(contract) {
			if (!contract.signeeTitle) {
				contract.signeeTitleOptionError = 'Valid input is required';
			} else {
				contract.signeeTitleOptionError = '';
			}
		}

		function sort(col) {
			if (scope.m.order && col === scope.m.order[0].substring(1, scope.m.order[0].length)) {
				if (scope.m.order[0].substring(0, 1) === '+') {
					scope.m.order[0] = scope.m.order[0].replace('+', '-');
				} else {
					scope.m.order[0] = scope.m.order[0].replace('-', '+');
				}
			} else {
				switch (col) {
				case 'contractName':
					scope.m.order = ['-contractName', '-version', '+rejected', '-dateSignedClean'];
					break;
				case 'version':
					scope.m.order = ['-version', '+contractName', '+rejected', '-dateSignedClean'];
					break;
				case 'signeeClean':
					scope.m.order = [
						'+signeeClean', '+signeeTitleClean', '+contractName', '-version', '+rejected',
						'-dateSignedClean'
					];
					break;
				case 'signeeTitleClean':
					scope.m.order = ['+signeeTitleClean', '+signeeClean', '+contractName', '-version', '+rejected'];
					break;
				case 'dateSignedSort':
					scope.m.order = [
						'-dateSignedSort', '+contractName', '-version', '+signeeClean', '+contractName',
						'+signeeTitleClean'
					];
					break;
				case 'brokerName':
					scope.m.order = ['+brokerName', '-lastVisited'];
					break;
				case 'signatureType':
					scope.m.order = ['-signatureType', '+brokerName'];
					break;
				case 'lastVisited':
					scope.m.order = ['-lastVisited', '+brokerName'];
					break;
				case 'signedContracts':
					scope.m.order = ['-signedContracts', '-lastVisited', '+brokerName'];
					break;
				}

			}
		}

		function searchClick() {
			scope.m.showAllBroker = false;
			scope.m.brokers = {};
		}

		function brokerClick(broker) {
			if (broker.open) {
				broker.open = false;
			}
			else if (broker.signedContracts) {
				loadSignatures(broker);
			}
		}

		function signatureClick(signature) {
			signature.isexpanded = !signature.isexpanded;
		}

		function goToBranded(broker) {
			sessionService.setDomain(broker.domain, scope);
		}

		function setReadyToSign() {
			scope.m.readyToSign = sessionService.getCarrierReadyToSign();
		}

		function openModalWindow() {
			scope.m.showConfirmationModal = true;
		}

		function closeModalWindow() {
			scope.m.signedNewContract = false;
			scope.m.showConfirmationModal = false;
			scope.m.isSubmited = true;
		}

		function logout() {
			authenticationService.logout();
		}
	}
})();
